import {
  YOTI,
  POST_OFFICE,
  YOTI_WITH_POST_OFFICE,
  DIDC
} from './skins-identifiers'

import {
  YOTI_THEME,
  POST_OFFICE_THEME,
  NEUTRAL_THEME
} from './themes-identifiers'

export function applyTheme(skinId) {
  const skinsClass = {
    default: YOTI_THEME,
    [YOTI]: YOTI_THEME,
    [POST_OFFICE]: POST_OFFICE_THEME,
    [YOTI_WITH_POST_OFFICE]: NEUTRAL_THEME,
    [DIDC]: NEUTRAL_THEME
  }
  const skinClass = skinsClass[skinId] || skinsClass.default
  document.body.setAttribute('class', skinClass)
}
